module.exports = __webpack_public_path__ + "img/264938549.c6150e39.jpg";